import { activityEntrySchema, paginated } from '@hearth/shared';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ActivityTable } from '@/components/activity-table';
import { Pagination } from '@/components/pagination';
import { QueryState } from '@/components/query-state';
import { apiRequest } from '@/lib/api';

export const Route = createFileRoute('/_app/account/activity')({
  validateSearch: (s: Record<string, unknown>): { page?: number } => ({
    page: Number(s.page) > 1 ? Number(s.page) : undefined,
  }),
  component: AccountActivity,
});

function AccountActivity() {
  const { page = 1 } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const query = useQuery({
    queryKey: ['account', 'activity', page],
    queryFn: ({ signal }) =>
      apiRequest(`/api/client/account/activity?page=${page}&perPage=25`, {
        schema: paginated(activityEntrySchema),
        signal,
      }),
    placeholderData: keepPreviousData,
  });
  return (
    <QueryState query={query}>
      {(data) => (
        <div className="space-y-4">
          <ActivityTable entries={data.data} showActor={false} />
          <Pagination {...data.meta} onPageChange={(p) => void navigate({ search: { page: p } })} />
        </div>
      )}
    </QueryState>
  );
}
